export default __webpack_public_path__ + "static/media/logo-large.e66f0430.svg";